import { HttpClient } from '@zeta-core';
import {
  APIResponse,
  IAllTranscriptsData,
  IClientDashboardDataResponse,
  IClientFinancialPlanningProgress,
  IEmptyRequestResponse,
  IFactFindDocumentsRequest,
  IFactFindDocumentsResponse,
  IGetDocumentHistoryResponse,
  IProfileSetupProgressResponse,
  IReportStatusRequest,
  IReportStatusResponse,
  ISearchDocumentsRequest,
  ISearchDocumentsResponse,
  ISingleTransciptDetailsRequest,
  ISingleTransciptDetailsResponse,
  IStageListResponse,
  IViewAdvisorUserRequest,
  IViewAdvisorUserResponse,
  IViewAuthorsOptionsResponse,
  IViewClientDashboardCountRequest,
  IViewClientDashboardCountResponse,
  IViewClientDashboardRequest,
  IViewClientDashboardResponse,
  IViewClientMeetingRequest,
  IViewClientMeetingResponse,
  IViewFFTimelineEventRequest,
  IViewFFTimelineEventResponse,
  IViewFactFindRequest,
  IViewFinancialPlanningProgressRequest,
  IViewFinancialSnapshotRequest,
  IViewFinancialSnapshotResponse,
  IViewMeetingsResponse,
  IViewRetailClientsResponse,
} from '@zeta-types';
import { QUERY_SERVICE } from '../services-path';

export const QueryAPIs = () => {
  return {
    clientDashboard: <T>(payload: IViewClientDashboardRequest<T>): APIResponse<IViewClientDashboardResponse<T>> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/dashboard/display`, payload),

    ClientDashboardCount: (payload: IViewClientDashboardCountRequest): APIResponse<IViewClientDashboardCountResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/dashboard/count`, payload),

    getFFReportStatus: (payload: IReportStatusRequest): APIResponse<IReportStatusResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/ff/report/readniess`, payload),

    viewClientMeetings: (payload: IViewClientMeetingRequest): APIResponse<IViewClientMeetingResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/meeting/dashboard/display`, payload),

    viewRetailClients: (payload: IEmptyRequestResponse): APIResponse<IViewRetailClientsResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/view/retailclients`, payload),

    viewAdvisorUsers: (payload: IViewAdvisorUserRequest): APIResponse<IViewAdvisorUserResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/users/display`, payload),

    profileSetupProgress: (payload: IEmptyRequestResponse): APIResponse<IProfileSetupProgressResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/profile/setup/progress`, payload),

    viewAllTranscript: (payload: IViewFactFindRequest): APIResponse<IAllTranscriptsData> => HttpClient.post(`${QUERY_SERVICE}/query/transcript/view`, payload),

    viewSingleAllTranscript: (payload: ISingleTransciptDetailsRequest): APIResponse<ISingleTransciptDetailsResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/transcript/detail`, payload),

    viewClientDashboard: (payload: IEmptyRequestResponse): APIResponse<IClientDashboardDataResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/retail/dashboard/view`, payload),

    viewMeetings: (payload: IEmptyRequestResponse): APIResponse<IViewMeetingsResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/retail/meeting/display`, payload),

    viewFinancialSnapshot: (payload: IViewFinancialSnapshotRequest): APIResponse<IViewFinancialSnapshotResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/client/financial/snapshot`, payload),

    viewFFTimelineEventDetails: (payload: IViewFFTimelineEventRequest): APIResponse<IViewFFTimelineEventResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/ff/event/view`, payload),

    viewStageList: (payload: IEmptyRequestResponse): APIResponse<IStageListResponse> => HttpClient.post(`${QUERY_SERVICE}/query/stage/list`, payload),

    getExistingClients: (payload: IEmptyRequestResponse): APIResponse<IStageListResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/client/individual/list`, payload),

    getExistingBusiness: (payload: { excludeClient: string }): APIResponse<IStageListResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/advisor/client/business/list`, payload),

    viewFinancialPlanningProgress: (payload: IViewFinancialPlanningProgressRequest): APIResponse<IClientFinancialPlanningProgress> =>
      HttpClient.post(`${QUERY_SERVICE}/query/client/financial-progress/display`, payload),

    // get fact find documents
    getFactFindDocuments: (payload: IFactFindDocumentsRequest): APIResponse<IFactFindDocumentsResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/ff/document/display`, payload),

    getAuthorsOptions: (payload: { clientID: string }): APIResponse<IViewAuthorsOptionsResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/author/view`, payload),

    searchDocuments: (payload: ISearchDocumentsRequest): APIResponse<ISearchDocumentsResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/vector/search`, payload),

    getDocumentHistory: (payload: { id: string }): APIResponse<IGetDocumentHistoryResponse> =>
      HttpClient.post(`${QUERY_SERVICE}/query/document/history`, payload),
  };
};
